export const tts_voices = {
  "zh": [
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_female_wanwanxiaohe_moon_bigtts",
      "voice_name": "湾湾小何",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/湾湾小何.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_female_linjianvhai_moon_bigtts",
      "voice_name": "邻家女孩",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/邻家女孩.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_male_yuanboxiaoshu_moon_bigtts",
      "voice_name": "渊博小叔",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/渊博小叔.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_male_yangguangqingnian_moon_bigtts",
      "voice_name": "阳光青年",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/阳光青年.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_female_wanqudashu_moon_bigtts",
      "voice_name": "湾区大叔",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/湾区大叔.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_female_daimengchuanmei_moon_bigtts",
      "voice_name": "呆萌川妹",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/呆萌川妹.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_male_guozhoudege_moon_bigtts",
      "voice_name": "广州德哥",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/广州德哥.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_male_beijingxiaoye_moon_bigtts",
      "voice_name": "北京小爷",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/北京小爷.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_male_haoyuxiaoge_moon_bigtts",
      "voice_name": "浩宇小哥",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/浩宇小哥.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_male_guangxiyuanzhou_moon_bigtts",
      "voice_name": "广西远舟",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/广西远舟.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_female_meituojieer_moon_bigtts",
      "voice_name": "妹坨洁儿",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/妹坨洁儿.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_male_yuzhouzixuan_moon_bigtts",
      "voice_name": "豫州子轩",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/豫州子轩.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_female_gaolengyujie_moon_bigtts",
      "voice_name": "高冷御姐",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/高冷御姐.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_male_aojiaobazong_moon_bigtts",
      "voice_name": "傲娇霸总",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/傲娇霸总.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_female_meilinvyou_moon_bigtts",
      "voice_name": "魅力女友",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/魅力女友.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_male_shenyeboke_moon_bigtts",
      "voice_name": "深夜播客",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/深夜播客.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_female_sajiaonvyou_moon_bigtts",
      "voice_name": "柔美女友",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/柔美女友.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_female_yuanqinvyou_moon_bigtts",
      "voice_name": "撒娇学妹",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/撒娇学妹.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "longwan",
      "voice_name": "龙婉 女",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://help-static-aliyun-doc.aliyuncs.com/file-manage-files/zh-CN/20240830/dzkngm/龙婉.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "longcheng",
      "voice_name": "龙橙 男",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://help-static-aliyun-doc.aliyuncs.com/file-manage-files/zh-CN/20240830/ggjwfl/龙橙.wav"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "longhua",
      "voice_name": "龙华 女童",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://help-static-aliyun-doc.aliyuncs.com/file-manage-files/zh-CN/20240830/jpjtvy/龙华.wav"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "longxiaochun",
      "voice_name": "龙小淳 女",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://help-static-aliyun-doc.aliyuncs.com/file-manage-files/zh-CN/20240624/rlfvcd/龙小淳.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "longxiaoxia",
      "voice_name": "龙小夏 女",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://help-static-aliyun-doc.aliyuncs.com/file-manage-files/zh-CN/20240624/wzywtu/龙小夏.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "longxiaocheng",
      "voice_name": "龙小诚 男",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://help-static-aliyun-doc.aliyuncs.com/file-manage-files/zh-CN/20240624/xrqksx/龙小诚.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "longxiaobai",
      "voice_name": "龙小白 女",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://help-static-aliyun-doc.aliyuncs.com/file-manage-files/zh-CN/20240624/vusvze/龙小白.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "longlaotie",
      "voice_name": "龙老铁 男 东北口音",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://help-static-aliyun-doc.aliyuncs.com/file-manage-files/zh-CN/20240624/pfsfir/龙老铁.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "longshu",
      "voice_name": "龙书 男",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://help-static-aliyun-doc.aliyuncs.com/file-manage-files/zh-CN/20240624/azcerd/龙书.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "longshuo",
      "voice_name": "龙硕 男",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://help-static-aliyun-doc.aliyuncs.com/file-manage-files/zh-CN/20240624/lcykpl/龙硕.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "longjing",
      "voice_name": "龙婧 女",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://help-static-aliyun-doc.aliyuncs.com/file-manage-files/zh-CN/20240624/ozkbmb/龙婧.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "longmiao",
      "voice_name": "龙妙 女",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://help-static-aliyun-doc.aliyuncs.com/file-manage-files/zh-CN/20240624/zjnqis/龙妙.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "longyue",
      "voice_name": "龙悦 女",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://help-static-aliyun-doc.aliyuncs.com/file-manage-files/zh-CN/20240624/nrkjqf/龙悦.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "longyuan",
      "voice_name": "龙媛 女",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://help-static-aliyun-doc.aliyuncs.com/file-manage-files/zh-CN/20240624/xuboos/龙媛.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "longfei",
      "voice_name": "龙飞 男",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://help-static-aliyun-doc.aliyuncs.com/file-manage-files/zh-CN/20240624/bhkjjx/龙飞.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "longjielidou",
      "voice_name": "龙杰力豆 男童",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://help-static-aliyun-doc.aliyuncs.com/file-manage-files/zh-CN/20240624/dctiyg/龙杰力豆.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "longtong",
      "voice_name": "龙彤 女童",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://help-static-aliyun-doc.aliyuncs.com/file-manage-files/zh-CN/20240624/qyqmvo/龙彤.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "longxiang",
      "voice_name": "龙祥 男",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://help-static-aliyun-doc.aliyuncs.com/file-manage-files/zh-CN/20240624/jybshd/龙祥.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "loongstella",
      "voice_name": "Stella 女",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://help-static-aliyun-doc.aliyuncs.com/file-manage-files/zh-CN/20240624/haffms/Stella.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "loongbella",
      "voice_name": "Bella 女",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://help-static-aliyun-doc.aliyuncs.com/file-manage-files/zh-CN/20240624/tguine/Bella.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_male_tiancaitongsheng_mars_bigtts",
      "voice_name": "天才童声",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/console/bigtts/zh_male_tiancaitongsheng_mars_bigtts.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_male_naiqimengwa_mars_bigtts",
      "voice_name": "奶气萌娃",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/console/bigtts/zh_male_naiqimengwa_mars_bigtts.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_male_sunwukong_mars_bigtts",
      "voice_name": "猴哥",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/console/bigtts/zh_male_sunwukong_mars_bigtts.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_male_xionger_mars_bigtts",
      "voice_name": "熊二",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/console/bigtts/zh_male_xionger_mars_bigtts.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_female_peiqi_mars_bigtts",
      "voice_name": "佩奇猪",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/console/bigtts/zh_female_peiqi_mars_bigtts.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_female_shaoergushi_mars_bigtts",
      "voice_name": "少儿故事",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/console/bigtts/zh_female_shaoergushi_mars_bigtts.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_female_yingtaowanzi_mars_bigtts",
      "voice_name": "樱桃丸子",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/console/bigtts/zh_female_yingtaowanzi_mars_bigtts.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_male_silang_mars_bigtts",
      "voice_name": "四郎",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/console/bigtts/zh_male_silang_mars_bigtts.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "ICL_zh_female_wuxi_tob",
      "voice_name": "元气甜妹",
      "language": "zh",
      "created_at": "2025-09-10T10:22:51.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/元气甜妹.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "ICL_zh_male_youmodaye_tob",
      "voice_name": "幽默大爷",
      "language": "zh",
      "created_at": "2025-09-10T10:22:51.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/console/bigtts/ICL_zh_male_youmodaye_tob.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "ICL_zh_female_heainainai_tob",
      "voice_name": "和蔼奶奶",
      "language": "zh",
      "created_at": "2025-09-10T10:22:51.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/和蔼奶奶.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_female_popo_mars_bigtts",
      "voice_name": "婆婆",
      "language": "zh",
      "created_at": "2025-09-10T10:22:51.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/console/bigtts/zh_female_popo_mars_bigtts.mp3"
    },
    {
      "status": 1,
      "top": false,
      "voice_id": "zh_female_shuangkuaisisi_moon_bigtts",
      "voice_name": "爽快思思 / Skye (en-US)",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/爽快思思.mp3"
    },
    {
      "status": 1,
      "top": false,
      "voice_id": "zh_male_jingqiangkanye_moon_bigtts",
      "voice_name": "京腔侃爷 / Harmony (en-US)",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/京腔侃爷.mp3"
    },
    {
      "status": 1,
      "top": false,
      "voice_id": "zh_female_mengyatou_mars_bigtts",
      "voice_name": "萌丫头 / Cutey (en-US)",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/console/bigtts/zh_female_mengyatou_mars_bigtts.mp3"
    },
    {
      "status": 1,
      "top": false,
      "voice_id": "zh_male_shaonianzixin_moon_bigtts",
      "voice_name": "少年梓辛 / Brayan (en-US)",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/少年梓辛.mp3"
    },
    {
      "status": 1,
      "top": false,
      "voice_id": "zh_male_wennuanahu_moon_bigtts",
      "voice_name": "温暖阿虎 / Alvin (en-US)",
      "language": "zh",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/温暖阿虎.mp3"
    }
  ],
  "en": [
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_female_shuangkuaisisi_moon_bigtts",
      "voice_name": "Skye (en-US)",
      "language": "en",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/Skye.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_male_jingqiangkanye_moon_bigtts",
      "voice_name": "Harmony (en-US)",
      "language": "en",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/Harmony.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_female_mengyatou_mars_bigtts",
      "voice_name": "Cutey (en-US)",
      "language": "en",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/console/bigtts/Cutey.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_male_shaonianzixin_moon_bigtts",
      "voice_name": "Brayan (en-US)",
      "language": "en",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/Brayan.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "zh_male_wennuanahu_moon_bigtts",
      "voice_name": "Alvin (en-US)",
      "language": "en",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/Alvin.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "en_male_smith_mars_bigtts",
      "voice_name": "Smith (en-GB)",
      "language": "en",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/console/bigtts/en_male_smith_mars_bigtts.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "en_female_emily_mars_bigtts",
      "voice_name": "Emily (en-GB)",
      "language": "en",
      "created_at": "2025-06-18T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/Emily.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "en_female_sarah_mars_bigtts",
      "voice_name": "sarah (en-AU)",
      "language": "en",
      "created_at": "2025-06-18T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/console/bigtts/en_female_sarah_mars_bigtts.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "en_male_dryw_mars_bigtts",
      "voice_name": "Dryw (en-AU)",
      "language": "en",
      "created_at": "2025-06-18T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/console/bigtts/en_male_dryw_mars_bigtts.mp3"
    },
    {
      "status": 1,
      "top": false,
      "voice_id": "zh_female_wanwanxiaohe_moon_bigtts",
      "voice_name": "湾湾小何",
      "language": "en",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/wanwanxiaohe.mp3"
    },
    {
      "status": 1,
      "top": false,
      "voice_id": "zh_female_linjianvhai_moon_bigtts",
      "voice_name": "邻家女孩",
      "language": "en",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/linjianvhai.mp3"
    },
    {
      "status": 1,
      "top": false,
      "voice_id": "zh_female_gaolengyujie_moon_bigtts",
      "voice_name": "高冷御姐",
      "language": "en",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/gaolengyujie.mp3"
    },
    {
      "status": 1,
      "top": false,
      "voice_id": "zh_female_meilinvyou_moon_bigtts",
      "voice_name": "魅力女友",
      "language": "en",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/meilinvyou.mp3"
    },
    {
      "status": 1,
      "top": false,
      "voice_id": "longjielidou",
      "voice_name": "龙杰力豆 男童",
      "language": "en",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/longjielidou.mp3"
    }
  ],
  "ja": [
    {
      "status": 1,
      "top": true,
      "voice_id": "multi_male_jingqiangkanye_moon_bigtts",
      "voice_name": "かずね（和音）",
      "language": "ja",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/和音.wav"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "multi_female_shuangkuaisisi_moon_bigtts",
      "voice_name": "はるこ（晴子）",
      "language": "ja",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/晴子.wav"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "multi_female_gaolengyujie_moon_bigtts",
      "voice_name": "あけみ（朱美）",
      "language": "ja",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/%E6%9C%B1%E7%BE%8E.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "multi_male_wanqudashu_moon_bigtts",
      "voice_name": "ひろし（広志）",
      "language": "ja",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://lf3-static.bytednsdoc.com/obj/eden-cn/lm_hz_ihsph/ljhwZthlaukjlkulzlp/portal/bigtts/広志.mp3"
    }
  ],
  "yue": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Cantonese_PlayfulMan",
      "voice_name": "粤语男声",
      "language": "yue",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/zx2ba6ee-40cf-4123-a6ae-394b2a682e49.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Cantonese_news_host_male_4",
      "voice_name": "港式男声",
      "language": "yue",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/7e9c5f58-63de-4dbe-976c-97bd99609981.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Cantonese_ProfessionalHost（F)",
      "voice_name": "粤语女声",
      "language": "yue",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/b6f1d4ea-6b38-4956-a245-8895d79fc6e2.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "HK_Cantonese_female1",
      "voice_name": "港式女声",
      "language": "yue",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/x117e244-0862-42b8-8571-2bd663da3c68.mp3"
    }
  ],
  "vi": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Vietnamese_kindhearted_girl",
      "voice_name": "越南语女声 / Giọng nữ",
      "language": "vi",
      "created_at": "2025-06-16T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/1e7cd75c-c97c-4b80-a70c-c1270c3fd18e.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Vietnamese_Serene_Man",
      "voice_name": "越南语男声 / giọng nam",
      "language": "vi",
      "created_at": "2025-06-16T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/24b645aa-dccb-4dea-9ea1-6d23567733aa.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "vc_vietnamese_voice_003_1011_1004",
      "voice_name": "越南语年轻女生 / cô gái trẻ",
      "language": "vi",
      "created_at": "2025-10-13T08:13:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_vc_vietnamese_voice_003_1011_1004.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "vc_vietnamese_voice_005_1011_1003",
      "voice_name": "越南语男主持 / chủ nhà nam",
      "language": "vi",
      "created_at": "2025-10-13T08:13:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_vc_vietnamese_voice_005_1011_1003.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "vc_vietnamese_voice_001_1011_1003",
      "voice_name": "越南语年轻男生 / chàng trai trẻ",
      "language": "vi",
      "created_at": "2025-10-13T08:13:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_vc_vietnamese_voice_001_1011_1003.mp3"
    }
  ],
  "fr": [
    {
      "status": 1,
      "top": true,
      "voice_id": "French_FemaleAnchor",
      "voice_name": "法语女声 / voix féminine",
      "language": "fr",
      "created_at": "2025-06-16T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/4f35412d-a042-4b46-9ccb-2e66f31c865c.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "French_MaleNarrator",
      "voice_name": "法语男声 / voix masculine",
      "language": "fr",
      "created_at": "2025-06-16T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/3f0c5917-4a50-4932-8613-e6d9c1b0d0c1.mp3"
    }
  ],
  "ar": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Arabic_CalmWoman",
      "voice_name": "阿拉伯语女声 / صوت أنثوي",
      "language": "ar",
      "created_at": "2025-06-16T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/b8edea98-f83e-4b43-9aee-171f55d806fd.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Arabic_FriendlyGuy",
      "voice_name": "阿拉伯语男声 / صوت ذكر",
      "language": "ar",
      "created_at": "2025-06-16T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/a5603952-d221-46e4-8702-9ff2ff02ee56.mp3"
    }
  ],
  "es": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Spanish_Kind-heartedGirl",
      "voice_name": "西班牙语女声 / voz femenina",
      "language": "es",
      "created_at": "2025-06-15T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/13c6a90b-4e50-4467-b71b-cc55cb8b212e.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Spanish_RomanticHusband",
      "voice_name": "西班牙语男声 / voz masculina",
      "language": "es",
      "created_at": "2025-06-15T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/07e64f89-c923-41fb-858c-3e40371e87c9.mp3"
    }
  ],
  "ru": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Russian_BrightHeroine",
      "voice_name": "俄语女声 / Женск голос",
      "language": "ru",
      "created_at": "2025-06-12T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/cfa23a0f-3d66-4550-966d-9d32c2317517.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Russian_ReliableMan",
      "voice_name": "俄语男声 / Мужск голос",
      "language": "ru",
      "created_at": "2025-06-12T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/b203774e-ed42-497a-b5a6-b6f7cdb11b0f.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Russian_Bad-temperedBoy",
      "voice_name": "俄语儿童 / ребенок",
      "language": "ru",
      "created_at": "2025-08-25T06:27:45.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Russian_Bad-temperedBoy.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Russian_CrazyQueen",
      "voice_name": "俄语女王 / сумасшедшая королева",
      "language": "ru",
      "created_at": "2025-08-25T06:27:45.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Russian_CrazyQueen.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Russian_AmbitiousWoman",
      "voice_name": "俄语女强人 / амбициозная женщина",
      "language": "ru",
      "created_at": "2025-08-25T06:27:45.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Croatian_female_1_v1.mp3"
    }
  ],
  "ko": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Korean_SoothingLady",
      "voice_name": "韩语女声 / 여성 목소리",
      "language": "ko",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/37d0eaf7-c4fc-4d2b-8501-44a7c9c27f46.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Korean_PlayboyCharmer",
      "voice_name": "韩语男声 / 남성",
      "language": "ko",
      "created_at": "2024-12-31T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/2db5ac29-c927-4c36-ba24-674708ad119c.mp3"
    }
  ],
  "it": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Italian_Narrator",
      "voice_name": "意大利语男声 / voce maschile",
      "language": "it",
      "created_at": "2025-06-22T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/4f44337f-747a-47e0-89e2-1403e77709b9.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Italian_DiligentLeader",
      "voice_name": "意大利语女声 / voce femminile",
      "language": "it",
      "created_at": "2025-06-22T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/590495ba-eb2e-4065-8ed2-cf90637d4690.mp3"
    }
  ],
  "id": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Indonesian_ReservedYoungMan",
      "voice_name": "印尼语男声 / Suara laki-laki",
      "language": "id",
      "created_at": "2025-06-22T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/f77a82f9-3070-4c0d-baf9-304eafae31b2.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Indonesian_CharmingGirl",
      "voice_name": "印尼语女声 / Suara Wanita",
      "language": "id",
      "created_at": "2025-06-22T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/acf168de-122a-4e3a-905f-8240d8419f0b.mp3"
    }
  ],
  "hi": [
    {
      "status": 1,
      "top": true,
      "voice_id": "legacy_vc_Hindi_samar_0623_1557",
      "voice_name": "印地语男声 / पुरुष की आवाज़",
      "language": "hi",
      "created_at": "2025-06-23T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/86bf2958-bf62-4278-a23b-8bf8cafbe3c7.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "legacy_vc_Hindi_vidya_0623_1558",
      "voice_name": "印地语女声 / महिला की आवाज़",
      "language": "hi",
      "created_at": "2025-06-23T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/1f16ab19-06fd-496a-a42b-ba58fa1391ad.mp3"
    }
  ],
  "fi": [
    {
      "status": 1,
      "top": true,
      "voice_id": "legacy_vc_finnish_christoffer_0623_1549",
      "voice_name": "芬兰语男声 / miehen ääni",
      "language": "fi",
      "created_at": "2025-06-23T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/f12795d5-f4ee-46a3-a54a-e0b9becf1a4d.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "legacy_vc_finnish_aava_0623_1549",
      "voice_name": "芬兰语女声 / Naisääni",
      "language": "fi",
      "created_at": "2025-06-23T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/e9805f7a-e4bd-4e81-ab54-8744590f1de2.mp3"
    }
  ],
  "th": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Thai_male_2_sample2",
      "voice_name": "泰语男声 / คำพูดของผู้ชาย",
      "language": "th",
      "created_at": "2025-06-23T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/39fa8d8c-e612-44ec-b832-755c12907b8.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Thai_Tender_Woman",
      "voice_name": "泰语女声 / คำพูดของผู้หญิง",
      "language": "th",
      "created_at": "2025-06-23T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/544ac11a-38c5-4b8d-aa48-2720e8c95458.mp3"
    }
  ],
  "de": [
    {
      "status": 1,
      "top": true,
      "voice_id": "German_FriendlyMan",
      "voice_name": "德语男声 / männliche Stimme",
      "language": "de",
      "created_at": "2025-06-24T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/5467369d-bf93-4bc4-b567-03aad674bae8.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "legacy_vc_German_lucy_0623_1553",
      "voice_name": "德语女声 / weibliche Stimme",
      "language": "de",
      "created_at": "2025-06-24T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/c15b93d6-525b-42fb-a4b3-5e4458e7e2c0.mp3"
    }
  ],
  "pt": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Portuguese_GentleTeacher",
      "voice_name": "葡萄牙语男声 / voz masculina",
      "language": "pt",
      "created_at": "2025-06-24T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/9da18e50-f352-478c-8656-da285ada7b0b.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Portuguese_ElegantGirl",
      "voice_name": "葡萄牙语女声 / voz Feminina",
      "language": "pt",
      "created_at": "2025-06-24T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/88d00a33-7a2f-4851-83da-941c32f4616f.mp3"
    }
  ],
  "uk": [
    {
      "status": 1,
      "top": true,
      "voice_id": "legacy_vc_ukrainian_anton_0623_1611",
      "voice_name": "乌克兰语男声 / чоловічий голос",
      "language": "uk",
      "created_at": "2025-06-24T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/d457a090-736f-4ce8-a5bc-65d8a4f94522.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "legacy_vc_ukrainian_alena_0623_1608",
      "voice_name": "乌克兰语女声 / Жіночий голос",
      "language": "uk",
      "created_at": "2025-06-24T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/6f2c04b1-b3f7-4eef-b9fb-669274cf469d.mp3"
    }
  ],
  "tr": [
    {
      "status": 1,
      "top": true,
      "voice_id": "legacy_vc_turkish_radio_0623_1606",
      "voice_name": "土耳其语男声 / Erkek sesi",
      "language": "tr",
      "created_at": "2025-06-24T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/7a3e528a-694d-4004-af70-6650e56888d6.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "legacy_vc_turkish_burcu_0623_1605",
      "voice_name": "土耳其语女声 / Kadın sesi",
      "language": "tr",
      "created_at": "2025-06-24T16:00:00.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/5a6e064f-cf4b-4076-ab9b-2391120c1d5b.mp3"
    }
  ],
  "cs": [
    {
      "status": 1,
      "top": true,
      "voice_id": "legacy_vc_czech_oliver_0623_1547",
      "voice_name": "捷克语男声 / mužský hlas",
      "language": "cs",
      "created_at": "2025-06-27T06:17:06.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/legacy_vc_czech_oliver_0623_1547.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "legacy_vc_czech_anet_0623_1545",
      "voice_name": "捷克语女声 / ženský hlas",
      "language": "cs",
      "created_at": "2025-06-27T06:33:38.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/legacy_vc_czech_anet_0623_1545.mp3"
    }
  ],
  "pl": [
    {
      "status": 1,
      "top": true,
      "voice_id": "legacy_vc_polish_jurek_0623_1601",
      "voice_name": "波兰语男声 / męski głos",
      "language": "pl",
      "created_at": "2025-06-27T06:35:19.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/legacy_vc_polish_jurek_0623_1601.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "legacy_vc_polish_hanna_0623_1559",
      "voice_name": "波兰语女声 / kobiecy głos",
      "language": "pl",
      "created_at": "2025-06-27T06:36:29.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/legacy_vc_polish_hanna_0623_1559.mp3"
    }
  ],
  "ro": [
    {
      "status": 1,
      "top": true,
      "voice_id": "legacy_vc_Romanian_jora_0623_1603",
      "voice_name": "罗马尼亚男声 / voce masculină",
      "language": "ro",
      "created_at": "2025-06-27T06:37:02.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/legacy_vc_Romanian_jora_0623_1603.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "legacy_vc_Romanian_lara_0623_1604",
      "voice_name": "罗马尼亚女声/ voce feminină",
      "language": "ro",
      "created_at": "2025-06-27T06:37:29.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/legacy_vc_Romanian_lara_0623_1604.mp3"
    }
  ],
  "ms": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Malay_male_1_v1",
      "voice_name": "马来语男声 / suara lelaki",
      "language": "ms",
      "created_at": "2025-08-14T08:52:03.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Malay_male_1_v1.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Malay_female_1_v1",
      "voice_name": "马来语女声 / suara perempuan",
      "language": "ms",
      "created_at": "2025-08-14T08:52:03.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Malay_female_1_v1.mp3"
    }
  ],
  "sl": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Slovenian_male_1_v1",
      "voice_name": "斯洛文尼亚语男声 / moški glas",
      "language": "sl",
      "created_at": "2025-08-14T08:52:03.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Slovenian_male_1_v1.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Slovenian_female_1_v2",
      "voice_name": "斯洛文尼亚语女声 / ženski glas",
      "language": "sl",
      "created_at": "2025-08-14T08:52:03.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Slovenian_female_1_v2.mp3"
    }
  ],
  "nl": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Dutch_bossy_leader",
      "voice_name": "荷兰语男声 / mannelijke stem",
      "language": "nl",
      "created_at": "2025-08-14T08:52:03.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Dutch_bossy_leader.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Dutch_kindhearted_girl",
      "voice_name": "荷兰语女声 / vrouwelijke stem",
      "language": "nl",
      "created_at": "2025-08-14T08:52:03.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Dutch_kindhearted_girl.mp3"
    }
  ],
  "bg": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Bulgarian_male_2_v1",
      "voice_name": "保加利亚语男声 / мъжки глас",
      "language": "bg",
      "created_at": "2025-08-14T08:52:03.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Bulgarian_male_2_v1.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Bulgarian_female_1_v1",
      "voice_name": "保加利亚语女声 / женски глас",
      "language": "bg",
      "created_at": "2025-08-14T08:52:03.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Bulgarian_female_1_v1.mp3"
    }
  ],
  "da": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Danish_male_1_v1",
      "voice_name": "丹麦语男声 / mandlig stemme",
      "language": "da",
      "created_at": "2025-08-14T08:52:03.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Danish_male_1_v1.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Danish_female_1_v1",
      "voice_name": "丹麦语女声 / kvindelig stemme",
      "language": "da",
      "created_at": "2025-08-14T08:52:03.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Danish_female_1_v1.mp3"
    }
  ],
  "he": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Hebrew_male_1_v1",
      "voice_name": "希伯来语男声 / מען זכר",
      "language": "he",
      "created_at": "2025-08-14T08:52:03.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Hebrew_male_1_v1.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Hebrew_female_1_v1",
      "voice_name": "希伯来语女声 / מען זכר",
      "language": "he",
      "created_at": "2025-08-14T08:52:03.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Hebrew_female_1_v1.mp3"
    }
  ],
  "sk": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Slovak_male_1_v1",
      "voice_name": "斯洛伐克语男声 / mužský hlas",
      "language": "sk",
      "created_at": "2025-08-14T08:52:03.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Slovak_male_1_v1.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Slovak_female_1_v1",
      "voice_name": "斯洛伐克语女声 / ženský hlas",
      "language": "sk",
      "created_at": "2025-08-14T08:52:03.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Slovak_female_1_v1.mp3"
    }
  ],
  "sv": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Swedish_male_1_v1",
      "voice_name": "瑞典语男声 / manlig röst",
      "language": "sv",
      "created_at": "2025-08-14T08:52:03.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Swedish_male_1_v1.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Swedish_female_1_v1",
      "voice_name": "瑞典语女声 / kvinnlig röst",
      "language": "sv",
      "created_at": "2025-08-14T08:52:03.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Swedish_female_1_v1.mp3"
    }
  ],
  "hr": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Croatian_male_1_v1",
      "voice_name": "克罗地亚语男声 / mužki glas",
      "language": "hr",
      "created_at": "2025-08-14T08:52:03.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Croatian_male_1_v1.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Croatian_female_1_v1",
      "voice_name": "克罗地亚语女声 / ženski glas",
      "language": "hr",
      "created_at": "2025-08-14T08:52:03.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Croatian_female_1_v1.mp3"
    }
  ],
  "hu": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Hungarian_male_1_v1",
      "voice_name": "匈牙利语男声 / férfi hang",
      "language": "hu",
      "created_at": "2025-08-14T08:52:03.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Hungarian_male_1_v1.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Hungarian_female_1_v1",
      "voice_name": "匈牙利语女声 / női hang",
      "language": "hu",
      "created_at": "2025-08-14T08:52:03.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Hungarian_female_1_v1.mp3"
    }
  ],
  "ca": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Catalan_male_1_v1",
      "voice_name": "加泰罗尼亚语男声 / veu masculina",
      "language": "ca",
      "created_at": "2025-08-14T08:52:03.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Catalan_male_1_v1.mp3"
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Catalan_female_1_v1",
      "voice_name": "加泰罗尼亚语女声 / veu femenina",
      "language": "ca",
      "created_at": "2025-08-14T08:52:03.000Z",
      "voice_demo": "https://xiaozhi-voice-assistant.oss-cn-shenzhen.aliyuncs.com/tts/tts_Catalan_female_1_v1.mp3"
    }
  ],
  "fa": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Persian_male_1_v1",
      "voice_name": "波斯语男声 / مرد",
      "language": "fa",
      "created_at": "2025-09-11T06:02:30.000Z",
      "voice_demo": ""
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Persian_female_1_v1",
      "voice_name": "波斯语女声 / زن",
      "language": "fa",
      "created_at": "2025-09-11T06:02:30.000Z",
      "voice_demo": ""
    }
  ],
  "el": [
    {
      "status": 1,
      "top": true,
      "voice_id": "legacy_vc_Greek_stefanos_0623_1555",
      "voice_name": "希腊语男声 / μπαστάνος",
      "language": "el",
      "created_at": "2025-09-11T06:02:30.000Z",
      "voice_demo": ""
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "legacy_vc_Greek_sofia_0623_1554",
      "voice_name": "希腊语女声 / σοφία",
      "language": "el",
      "created_at": "2025-09-11T06:02:30.000Z",
      "voice_demo": ""
    }
  ],
  "no": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Norwegian_male_1_v1",
      "voice_name": "挪威语男声 / mannlig stemme",
      "language": "no",
      "created_at": "2025-09-11T06:02:30.000Z",
      "voice_demo": ""
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Norwegian_female_1_v1",
      "voice_name": "挪威语女声 / kvinnelig stemme",
      "language": "no",
      "created_at": "2025-09-11T06:02:30.000Z",
      "voice_demo": ""
    }
  ],
  "fil": [
    {
      "status": 1,
      "top": true,
      "voice_id": "Filipino_male_1_v1",
      "voice_name": "菲律宾语男声 / lalaki",
      "language": "fil",
      "created_at": "2025-09-11T06:02:30.000Z",
      "voice_demo": ""
    },
    {
      "status": 1,
      "top": true,
      "voice_id": "Filipino_female_1_v1",
      "voice_name": "菲律宾语女声 / babae",
      "language": "fil",
      "created_at": "2025-09-11T06:02:30.000Z",
      "voice_demo": ""
    }
  ]
}

export const languages = [
    { label : '普通话' , value : 'zh' },
    { label : '英文' , value : 'en' },
    { label : '日语' , value : 'ja' },
    { label : '粤语' , value : 'yue' },
    { label : '越南语' , value : 'vi' },
    { label : '法语' , value : 'fr' },
    { label : '阿拉伯语' , value : 'ar' },
    { label : '西班牙语' , value : 'es' },
    { label : '俄语' , value : 'ru' },
    { label : '韩语' , value : 'ko' },
    { label : '意大利语' , value : 'it' },
    { label : '印尼语' , value : 'id' },
    { label : '印地语' , value : 'hi' },
    { label : '芬兰语' , value : 'fi' },
    { label : '泰语' , value : 'th' },
    { label : '德语' , value : 'de' },
    { label : '葡萄牙语' , value : 'pt' },
    { label : '乌克兰语' , value : 'uk' },
    { label : '土耳其语' , value : 'tr' },
    { label : '捷克语' , value : 'cs' },
    { label : '波兰语' , value : 'pl' },
    { label : '罗马尼亚语' , value : 'ro' },
    { label : '马来语' , value : 'ms' },
    { label : '斯洛文尼亚语' , value : 'sl' },
    { label : '荷兰语' , value : 'nl' },
    { label : '保加利亚语' , value : 'bg' },
    { label : '丹麦语' , value : 'da' },
    { label : '希伯来语' , value : 'he' },
    { label : '斯洛伐克语' , value : 'sk' },
    { label : '瑞典语' , value : 'sv' },
    { label : '克罗地亚语' , value : 'hr' },
    { label : '匈牙利语' , value : 'hu' },
    { label : '加泰罗尼亚语' , value : 'ca' },
    { label : '波斯语' , value : 'fa' },
    { label : '希腊语' , value : 'el' },
    { label : '挪威语' , value : 'no' },
    { label : '菲律宾语' , value : 'fil' },
]